// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2709":"f7cf76e852e533ad","7065":"bd68861708472471"}[chunkId] + ".css";
};